import styled from 'styled-components'
import { Pencil } from '@styled-icons/evil/Pencil'
import { Trash } from '@styled-icons/bootstrap/Trash'
import { GrayLight } from '../../../constants/constants'
export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
`

export const Line = styled.hr`
  display: flex;
  border: 0;
  height: 1px;
  border-color: #d3d3d3;
  background-color: #d3d3d3;
  width: 100%;
`

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
`
export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
export const Title = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 11pt;
  font-weight: bold;
`

export const SubTitle = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 9pt;
`
export const IconsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
  height: 100%;
  align-items: center;
`

export const EditButton = styled(Pencil)`
  color: ${GrayLight};
  cursor: pointer;
  transition-duration: 0.4s;
  &:hover {
    color: black;
  }
`

export const TrashButton = styled(Trash)`
  color: ${GrayLight};
  cursor: pointer;
  transition-duration: 0.4s;
  &:hover {
    color: black;
  }
`

export const InfoBody = styled.div`
  margin-top: 8px;
  font-size: 10pt;
  white-space: pre-line;
  text-align: justify;
`
